import { Outlet } from "react-router-dom";
import { PWAGate } from "@/components/pwa/pwa-gate";

/**
 * 앱 전체를 감싸는 루트 레이아웃
 * PWAGate로 PWA 접근 제어를 처리함
 */
export function RootLayout() {
  return (
    <PWAGate>
      <Outlet />
    </PWAGate>
  );
}
